import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TemplateService } from '../services';

@Component({
    selector: 'briefing-settings-editor',
    template: `
        <div [formGroup]="form" fxLayout="column" style="padding: 10px;">
            <mat-checkbox formControlName="published" style="padding-bottom: 10px;">Publish</mat-checkbox>
            <mat-form-field>
                <input matInput type="text" placeholder="Title" formControlName="briefingTitle">
                <mat-error *ngIf="form.get('briefingTitle').hasError('required')">Title cannot be blank</mat-error>
            </mat-form-field>
            <mat-form-field>
                <input matInput type="text" placeholder="Description" formControlName="description">
                <mat-error *ngIf="form.get('description').hasError('required')">Description cannot be blank</mat-error>
            </mat-form-field>
            <ng-container formGroupName="commentary">
                <mat-form-field>
                    <input matInput type="text" placeholder="Commentary Title" formControlName="title">
                </mat-form-field>
                <div fxLayout="column" style="padding-bottom: 15px;">
                    <div fxFlex style="padding-bottom: 5px;">
                        <mat-label style="color: rgba(0,0,0,0.54);">Content</mat-label>
                    </div>
                    <div fxFlex>
                        <attensa-editor formControlName="body"></attensa-editor>
                    </div>
                </div>
            </ng-container>
            <mat-form-field>
                <input matInput type="text" placeholder="Subject Line" formControlName="subjectLine">
            </mat-form-field>
            <mat-form-field>
                <input matInput type="text" placeholder="Header Image URL" formControlName="templateHeaderImageUrl">
                <mat-error *ngIf="form.get('templateHeaderImageUrl').hasError('pattern')">Must be a valid URL.</mat-error>
            </mat-form-field>
            <mat-form-field>	
                <mat-select placeholder="Template" formControlName="templateId">	
                    <mat-option *ngFor="let template of templates" [value]="template.id">{{template.title}}</mat-option>	
                </mat-select>
                <mat-error *ngIf="form.get('templateId').hasError('required')">Template is required</mat-error>
            </mat-form-field>
        </div>
        <div style="text-align: center;">
            <h4>Your team from and reply to email addresses are set in the Briefing Settings section of <a [routerLink]="['/settings/account']">Account Settings</a>.</h4>
        </div>
    `
})
export class BriefingSettingsEditorComponent implements OnInit  {
    @Input() form : FormGroup;
    templates: any[];

    constructor(private templateService: TemplateService) {}
    
    ngOnInit(): void {
        this.templateService.getAllUnauth().subscribe(templates => {
            this.templates = templates;
            const templateIdControl = this.form.controls.templateId;
            if (templates.length === 1 && (!templateIdControl.value || templateIdControl.value?.trim()?.length() === 0)) {
                templateIdControl.setValue(templates[0].id);
            }
        });
    }
}